import { useEffect, useState } from 'react';
import { mapValues, isEmpty } from 'lodash';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

import convertErrors from '../utils/convertErrors';

const patientForm = {
  [PROFILE_FIELDS_TYPES.FIRST_NAME]: '',
  [PROFILE_FIELDS_TYPES.LAST_NAME]: '',
  [PROFILE_FIELDS_TYPES.NAME_SUFFIX]: '',
  [PROFILE_FIELDS_TYPES.DOB]: '',
  [PROFILE_FIELDS_TYPES.SSN]: '',
  [PROFILE_FIELDS_TYPES.LOCAL_UID]: '',
};

export function usePatientFormState(initialState = patientForm) {
  const [patientState, setPatientInfo] = useState(initialState);

  function handlePatientFormChange(value) {
    setPatientInfo({ ...patientState, ...value });
  }

  function clearPatientForm() {
    setPatientInfo(mapValues(patientState, () => ''));
  }

  return { patientState, handlePatientFormChange, clearPatientForm };
}

export function usePatientValidation(dataValidationErrors) {
  const [validateErrors, setValidateErrors] = useState({});

  useEffect(() => {
    if (dataValidationErrors) {
      setValidateErrors(convertErrors(dataValidationErrors));
    }
  }, [dataValidationErrors]);

  function clearErrors() {
    setValidateErrors({});
  }

  return { validateErrors, clearErrors };
}

const patientRequiredFields = [
  PROFILE_FIELDS_TYPES.FIRST_NAME,
  PROFILE_FIELDS_TYPES.LAST_NAME,
  PROFILE_FIELDS_TYPES.DOB,
];

export function validateRequiredFields(patientData) {
  return patientRequiredFields.every(type => !isEmpty(patientData[type]));
}

// use for page validation

export const PATIENT_INFO_FIELDS = [
  ...patientRequiredFields,
  PROFILE_FIELDS_TYPES.NAME_SUFFIX,
  PROFILE_FIELDS_TYPES.SSN,
  PROFILE_FIELDS_TYPES.LOCAL_UID,
];



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationInfo/usePatientForm.jsx